import { Card, Col, Table } from 'react-bootstrap'
import moment from 'moment'
import TextInformationLine from '../text-information-line'
import { Link } from 'react-router-dom'
import { useState } from 'react'
import { UpdateOrgSubscriptionIdModal } from 'components/organization-details-page/update-org-subscription-id-modal'
import useOrganizationSubscriptionItems from 'hooks/use-organization-subscription-items'
import HubSpotButton from 'components/hubspot-button'

const UserOrganizationCard = ({
  org,
  accountManagerName,
  salesRepName,
  userName,
}: {
  org: any
  accountManagerName?: string
  salesRepName?: string
  userName?: string
}) => {
  const [copiedField, setCopiedField] = useState<string | null>(null)
  const [showSubscriptionIdUpdateModal, setShowSubscriptionIdUpdateModal] =
    useState(false)
  const { data: subscriptionItems } = useOrganizationSubscriptionItems(org?.id)

  const orgSub = org?.organization_subscription
  const isInHouseTrial =
    orgSub?.subscription_status === 'trialing' &&
    orgSub?.trial_end &&
    orgSub?.subscription_id?.includes('trial')

  const handleCopy = (text: string, field: string) => {
    navigator.clipboard.writeText(text)
    setCopiedField(field)
    setTimeout(() => setCopiedField(null), 3000)
  }

  const CopyableField = ({ text, field }: { text: string; field: string }) => (
    <div
      onClick={() => handleCopy(text, field)}
      style={{ cursor: 'pointer', display: 'inline-block' }}
      title={copiedField === field ? 'Copied!' : 'Click to copy'}
    >
      {text}{' '}
      <ion-icon
        name={copiedField === field ? 'checkmark-outline' : 'copy-outline'}
        style={{
          color: copiedField === field ? '#28a745' : '#4da6ff',
          fontSize: '16px',
        }}
      />
    </div>
  )

  return (
    <Col md="12">
      <Card className="mt-4">
        <Card.Header>
          <h4>User Organization</h4>
        </Card.Header>
        <Card.Body>
          {org ? (
            <>
              {org.internal_crm_url && (
                <div style={{ marginBottom: '12px' }}>
                  <HubSpotButton url={org.internal_crm_url} />
                </div>
              )}
              <TextInformationLine
                label="Org ID"
                data={<CopyableField text={org.id.toString()} field="orgId" />}
              />
              <TextInformationLine
                label="Org Name"
                data={
                  <Link
                    to={`/organizations/${org.id}`}
                    style={{ color: '#4da6ff', textDecoration: 'underline' }}
                  >
                    {org.name}
                  </Link>
                }
              />
              <TextInformationLine
                label="Account Manager"
                data={accountManagerName || 'N/A'}
              />
              <TextInformationLine
                label="Sales Rep"
                data={salesRepName || 'N/A'}
              />
              <TextInformationLine
                label="Created At"
                data={moment(org.created_at).format('LLL')}
              />
              {orgSub && (
                <>
                  <div style={{ marginBottom: '10px' }}>
                    <strong>Stripe Subscription: </strong>
                    <span>
                      {!isInHouseTrial ? (
                        <a
                          href={`https://dashboard.stripe.com/subscriptions/${orgSub.subscription_id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {orgSub.subscription_id}
                        </a>
                      ) : (
                        orgSub.subscription_id
                      )}{' '}
                      <span
                        style={{
                          color: '#4da6ff',
                          cursor: 'pointer',
                        }}
                        onClick={(e) => {
                          e.stopPropagation()
                          setShowSubscriptionIdUpdateModal(true)
                        }}
                      >
                        (edit)
                      </span>
                    </span>
                  </div>

                  <Table striped bordered hover responsive variant="dark">
                    <thead>
                      <tr>
                        <th>Product</th>
                        <th>Status</th>
                        <th>Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {subscriptionItems &&
                        subscriptionItems.length > 0 &&
                        subscriptionItems.map((item) => (
                          <tr key={item.product_name}>
                            <td>{item.product_name}</td>
                            <td>{item.status}</td>
                            <td>{item.quantity}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </>
              )}
            </>
          ) : (
            <p>{userName || 'User'} is not associated with any organization</p>
          )}
        </Card.Body>
      </Card>

      {org && (
        <UpdateOrgSubscriptionIdModal
          show={showSubscriptionIdUpdateModal}
          handleClose={() => setShowSubscriptionIdUpdateModal(false)}
          org={org}
          setShowSubscriptionIdUpdateModal={setShowSubscriptionIdUpdateModal}
        />
      )}
    </Col>
  )
}

export default UserOrganizationCard
